import { isEmpty, isInteger } from 'lodash'
import { NOW_PREFIX, VALUE, conditions } from './constants'

export const buildRule = ({
  params,
  isTriggered,
  setRule,
  data,
  isNumberDate,
  number
}) => {
  const { label, value } = params

  const labelToRemove = data.valueField.label
  const valueToRemove = data.valueField.value

  setRule((prev) => ({
    ...prev,
    label: isTriggered
      ? subtractPrevText(prev.label, labelToRemove, label, isNumberDate, number)
      : prev.label + label,
    value: isTriggered
      ? subtractPrevText(
          prev.value,
          valueToRemove,
          value,
          isNumberDate,
          number,
          true
        )
      : prev.value + value
  }))
}

const subtractPrevText = (
  text,
  textToRemove,
  newText,
  isNumberDate,
  number,
  isValue
) => {
  // For input text we need to remove previous value and to substitute with new,
  // because every typing triggers onChange func

  let textToRemoveLength = textToRemove.length
  let newValue = newText
  let strWithoutOldValue = text.slice(0, text.length - textToRemoveLength)
  const nowPrefixText = NOW_PREFIX[isValue ? 'value' : 'label']
  if (isNumberDate) {
    if (isEmpty(textToRemove)) {
      newValue = `${nowPrefixText}'${number} days'`
      return text + newValue
    }
    textToRemoveLength = `${nowPrefixText}'${textToRemove} days'`.length
    newValue = `${nowPrefixText}'${number} days'`
    strWithoutOldValue = text.slice(0, text.length - textToRemoveLength)
  }

  return strWithoutOldValue + newValue
}

export const cleanValue = (str) => {
  // First check if
  const excludedStr = [conditions.AND.value, conditions.OR.value]
  let resultStr = str
  excludedStr.forEach((key) => {
    const lastWord = str.slice(str.length - key.length, str.length)
    if (excludedStr.includes(lastWord)) {
      resultStr = subtractPrevText(str, key, '')
    }
  })
  return resultStr
}

export const manageSuperscripts = (params, field) => {
  if (field === VALUE && !isInteger(params.value)) {
    const cleanedValue = params.value.slice(1, -1)
    params.value = `'${cleanedValue}'`

    return params
  } else return params
}
